import './css/Header.css';
import gillassoc_header from './images/gillassoc_header.jpg';

function Header() {
  return (
      <div className="header">
        <img src={gillassoc_header} alt="Gill Associates Photography - A Full Service studio" />
      </div>
  );
}

export default Header;
